import { useState } from 'react';
import { FiPhone, FiMail, FiClock, FiFacebook, FiInstagram, FiLinkedin, FiMenu, FiX, FiChevronDown, FiYoutube } from 'react-icons/fi';
import logo from '../assets/logoFull.png';

const Header = ({ onNavigate, currentPage }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleNavClick = (e, page) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate(page);
    }
    setMobileMenuOpen(false);
  };

  const isAboutActive = currentPage === 'about-company';

  return (
    <header>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-left">
            <span className="top-bar-item">
              <FiPhone /> (021) 3873 3019
            </span>
            <span className="top-bar-separator">*</span>
            <span className="top-bar-item">
              <FiMail /> marketing@shuanghuipower.com
            </span>
            <span className="top-bar-separator">*</span>
            <span className="top-bar-item">
              <FiClock /> Sen - Jum: 08:00 - 17:00
            </span>
          </div>
          <div className="top-bar-right">
            <a href="https://www.instagram.com/shuanghui_id/?hl=en" aria-label="Instagram"><FiInstagram /></a>
            <a href="https://www.linkedin.com/company/pt-sh-power-indonesia/posts/?feedView=all" aria-label="LinkedIn"><FiLinkedin /></a>
            <a href="https://youtu.be/QteyDfg3usY?si=nywpIZL9BJVg2xJJ" aria-label="Youtube"><FiYoutube /></a>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="header-main">
        <div className="container">
          <a href="#" className="logo" onClick={(e) => handleNavClick(e, 'home')}>
            <img 
              src={logo}
              alt="Shuanghui Power"
              className="logo-image"
            />
          </a>

          <nav>
            <ul className="nav-menu">
              <li className={currentPage === 'home' ? 'active' : ''}>
                <a href="#" onClick={(e) => handleNavClick(e, 'home')}>Home</a>
              </li>

              {/* About Us Dropdown */}
              <li className={`has-dropdown ${isAboutActive ? 'active' : ''}`}>
                <a href="#" onClick={(e) => handleNavClick(e, 'about-company')}>
                  About Us <FiChevronDown className="dropdown-icon" />
                </a>
                <ul className="dropdown-menu">
                  <li className="has-submenu">
                    <a href="#" onClick={(e) => handleNavClick(e, 'about-company')}>Company</a>
                    <ul className="submenu">
                      <li><a href="#" onClick={(e) => handleNavClick(e, 'about-company')}>About Us</a></li>
                      <li><a href="#">History</a></li>
                    </ul>
                  </li>
                </ul>
              </li>

              {/* Product Dropdown */}
              <li className={`has-dropdown ${currentPage === 'products' || currentPage === 'product-detail' ? 'active' : ''}`}>
                <a href="#" onClick={(e) => handleNavClick(e, 'products')}>
                  Product <FiChevronDown className="dropdown-icon" />
                </a>
                <ul className="dropdown-menu">
                  {/* Manufactured Products */}
                  <li className="has-submenu">
                    <a href="#" onClick={(e) => handleNavClick(e, 'products')}>Manufactured Products</a>
                    <ul className="submenu">
                      <li><a href="#" onClick={(e) => handleNavClick(e, 'products')}>All Products</a></li>
                      <li><a href="#" onClick={(e) => handleNavClick(e, 'products')}>Air Insulated Switchgear</a></li>
                      <li><a href="#" onClick={(e) => handleNavClick(e, 'products')}>Gas Insulated Switchgear</a></li>
                      <li><a href="#" onClick={(e) => handleNavClick(e, 'products')}>Metal Clad</a></li>
                    </ul>
                  </li>

                  {/* Global Products */}
                  <li className="has-submenu">
                    <a href="#" onClick={(e) => handleNavClick(e, 'products')}>Global Supply Products</a>
                    <ul className="submenu">
                      <li><a href="https://www.shpowerglobal.com/product-category/transformer/" target="_blank" rel="noopener noreferrer">Transformer</a></li>
                      <li><a href="#" >Generator Set</a></li>
                      <li><a href="https://www.shpowerglobal.com/product-category/hardware-fitting/" >Power Fitting & Accessories</a></li>
                      <li><a href="https://www.shpowerglobal.com/product-category/composite-insulators/" >Composite Insulator</a></li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li><a href="#">Career</a></li>

              <li><a href="#article">Article</a></li>
            </ul>
          </nav>

          <div className="header-cta">
            <a href="#contact" className="btn btn-primary">Contact Us</a>
          </div>

          <div
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="mobile-menu">
            <ul>
              <li><a href="#" onClick={(e) => handleNavClick(e, 'home')}>Home</a></li>
              <li className="mobile-dropdown">
                <span className="mobile-dropdown-title">About Us</span>
                <ul className="mobile-submenu">
                  <li className="mobile-dropdown">
                    <span className="mobile-dropdown-title">Company</span>
                    <ul className="mobile-submenu">
                      <li><a href="#" onClick={(e) => handleNavClick(e, 'about-company')}>About Us</a></li>
                      <li><a href="#" onClick={() => setMobileMenuOpen(false)}>History</a></li>
                      <li><a href="#" onClick={() => setMobileMenuOpen(false)}>Career</a></li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li className="mobile-dropdown">
                <span className="mobile-dropdown-title">Product</span>
                <ul className="mobile-submenu">
                  <li><a href="#" onClick={(e) => handleNavClick(e, 'products')}>All Products</a></li>
                  <li><a href="#" onClick={(e) => handleNavClick(e, 'products')}>Air Insulated Switchgear</a></li>
                  <li><a href="#" onClick={(e) => handleNavClick(e, 'products')}>Gas Insulated Switchgear</a></li>
                  <li><a href="#" onClick={(e) => handleNavClick(e, 'products')}>Metal Clad</a></li>
                </ul>
              </li>
              <li><a href="#article" onClick={() => setMobileMenuOpen(false)}>Article</a></li>
              <li><a href="#contact" className="btn btn-primary" onClick={() => setMobileMenuOpen(false)}>Contact Us</a></li>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
